import { jsxs as i, jsx as l } from "react/jsx-runtime";
const o = (e) => /* @__PURE__ */ i("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, fill: "none", ...e, children: [
  /* @__PURE__ */ l("rect", { width: 40, height: 40, fill: "#F05F4C", rx: 20 }),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m20.5 23.328 6.086 6.086 2.828-2.828-6.086-6.086 6.086-6.086-2.828-2.828-6.086 6.086-6.086-6.086-2.828 2.828 6.086 6.086-6.086 6.086 2.828 2.828 6.086-6.086Z",
      clipRule: "evenodd"
    }
  )
] });
export {
  o as IconSmallError
};
